@import '~less/global-variables';

/**
 * TrustRoots core typography styles
 */

// Font mixins
.font-brand-light() {
  font-family: @font-family-brand-light;
  font-style: normal;
  font-weight: @font-weight-brand-light;
}
.font-brand-regular() {
  font-family: @font-family-brand-regular;
  font-style: normal;
  font-weight: @font-weight-brand-regular;
}
.font-brand-semibold() {
  font-family: @font-family-brand-semibold;
  font-style: normal;
  font-weight: @font-weight-brand-semibold;
}

// Helper classes
.font-brand-light {
  .font-brand-light();
}
.font-brand-regular {
  .font-brand-regular();
}
.font-brand-semibold {
  .font-brand-semibold();
}

::selection {
  background: @text-highlight;
  color: @text-highlight-color;
}

h1,
h2,
h3,
h4 {
  .font-brand-regular();
}

blockquote {
  font-size: @font-size-base;
}

.undecorated-link {
  &,
  &:active,
  &:focus,
  &:hover {
    text-decoration: none;
  }
}

.text-color-links {
  a {
    color: @text-color;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
}

/**
 * Offer colors
 * - Offer type `hosting`, `status`: yes|maybe
 * - Offer type `meet`
 */
.offer-hosting-yes {
  color: @offer-hosting-yes;
}
.offer-hosting-maybe {
  color: @offer-hosting-maybe;
}
.offer-hosting-no {
  color: @offer-hosting-no;
}
.offer-meet {
  color: @offer-meet;
}
